import { qualitySchema } from '@wyn/content';
import { z } from 'zod';

/** Moves the haggling engine accepts. Must match game-core's `HagglingMove`. */
export const hagglingMoveSchemas = [
  z.object({ type: z.literal('ask'), price: z.number().int().min(1).max(1_000_000) }),
  z.object({ type: z.literal('take') }),
  z.object({ type: z.literal('walk') }),
  z.object({ type: z.literal('pawn') }),
  z.object({ type: z.literal('keep') }),
] as const;

export const hagglingViewSchema = z.object({
  ware: z.object({ itemKey: z.string(), quality: qualitySchema, value: z.number() }),
  trader: z.string(),
  patience: z.number().int(),
  maxPatience: z.number().int(),
  counter: z.number().int().nullable(),
  say: z.string(),
  minPrice: z.number().int(),
  maxPrice: z.number().int(),
  pawnPrice: z.number().int(),
  /** The most the trader will pay for anything. */
  purse: z.number().int(),
  /** The trader has lost patience: pawn it or keep it. */
  walkedOff: z.boolean(),
  over: z.union([z.object({ kind: z.enum(['sold', 'pawned']), price: z.number().int() }), z.object({ kind: z.literal('kept') })]).nullable(),
  /** The trader's secret limit, revealed once it is over. */
  limit: z.number().int().nullable(),
});
export type HagglingView = z.infer<typeof hagglingViewSchema>;
